import type { ReactElement } from 'react';

import BeachIconLg from '@skyscanner/backpack-web/bpk-component-icon/lg/beach';
import BusIconLg from '@skyscanner/backpack-web/bpk-component-icon/lg/bus';
import EntertainmentIconLg from '@skyscanner/backpack-web/bpk-component-icon/lg/content--event';
import DealsIconLg from '@skyscanner/backpack-web/bpk-component-icon/lg/deals';
import FastTrainStationIconLg from '@skyscanner/backpack-web/bpk-component-icon/lg/fast-train';
import AirportIconLg from '@skyscanner/backpack-web/bpk-component-icon/lg/flight';
import RestaurantIconLg from '@skyscanner/backpack-web/bpk-component-icon/lg/food';
import TrainStationIconLg from '@skyscanner/backpack-web/bpk-component-icon/lg/train';
import BeachIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/beach';
import BusIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/bus';
import EntertainmentIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/content--event';
import DealsIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/deals';
import FastTrainStationIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/fast-train';
import AirportIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/flight';
import RestaurantIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/food';
import TrainStationIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/train';

import {
  AIRPORT,
  TRAIN_STATION,
  RESTAURANT,
  BUS_STATION,
  BEACH,
  SHOPPING_MALL,
  LEISURE_CENTER_BUILDING,
  METRO_STATION,
} from '@shared/constants/poi-types';

interface IconMapType {
  [key: string]: {
    lg: ReactElement;
    sm: ReactElement;
  };
}

const PoiIconMap: IconMapType = {
  [AIRPORT]: {
    lg: AirportIconLg,
    sm: AirportIconSm,
  },
  [TRAIN_STATION]: {
    lg: TrainStationIconLg,
    sm: TrainStationIconSm,
  },
  [METRO_STATION]: {
    lg: FastTrainStationIconLg,
    sm: FastTrainStationIconSm,
  },
  [RESTAURANT]: {
    lg: RestaurantIconLg,
    sm: RestaurantIconSm,
  },
  [BUS_STATION]: {
    lg: BusIconLg,
    sm: BusIconSm,
  },
  [BEACH]: {
    lg: BeachIconLg,
    sm: BeachIconSm,
  },
  [SHOPPING_MALL]: {
    lg: DealsIconLg,
    sm: DealsIconSm,
  },
  [LEISURE_CENTER_BUILDING]: {
    lg: EntertainmentIconLg,
    sm: EntertainmentIconSm,
  },
};

export default PoiIconMap;
